<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class="base-header__container">
                    <div class="d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            Веза са правним актима ЕУ
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec p-4">

                <!--                <iframe id="FpEurlex" src="http://localhost:8080/static-data/eurlex-1.html"-->
                <!--                        width="100%" height="600px" frameborder="0"></iframe>-->

                <iframe
                    :src="baseApiUrl + 'prins/viewdoc?uuid=7aed2854-a744-40f1-ad19-b5f6598544e2&staticpageid=12&doctype=fpstaticpage'"
                    width="100%" height="600px" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "FpEurlex",
    data() {
        return {
            loaded: false,

            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    mounted() {
        //
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }

}
</script>

<style >
#FpEurlex {}
</style>
